/* ClipDock — orchestrator shell for the clipboard dock.
 *
 * `.dock` is the positioned root (anchors the absolute SendConfirmPopover
 * + toast/tip live regions). Collapsed it hosts ClipDockBar; expanded it
 * swaps to the composer + RECENT history list. */

.dock {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  padding: var(--spacing-8);
  border-top: 1px solid var(--stroke-neutral);
  background: var(--bg-secondary);
}

/* Continuous with the dock surface — no border/radius/fill of its own, so the
 * expanded panel reads as one surface with the collapsed bar above it rather
 * than a box nested inside the dock's box. */
.expanded {
  display: flex;
  flex-direction: column;
  /* Section rhythm 12/4/12: composer→RECENT and list→collapse are 12px, but the
   * heading hugs its own list at 4px (see .recentHeading) so "RECENT" reads as a
   * label for the rows below it, not a free-floating row between two gaps. */
  gap: var(--spacing-12);
  padding: 0;
  max-height: 40vh;
  overflow-y: auto;
}

.composer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: var(--spacing-8);
}

.composer > :first-child {
  flex: 1;
  min-width: 0;
}

.recentHeading {
  letter-spacing: 0.08em;
  /* Pull the list/empty-state up under the heading: .expanded's 12px gap minus
   * this calc (which evaluates to −8px) nets the heading→list gap to 4px, so the
   * label hugs its rows. */
  margin-bottom: calc(var(--spacing-4) - var(--spacing-12));
}

.list {
  display: flex;
  flex-direction: column;
  /* gap:0 — flattened ClipCard rows carry their own padding + hairline divider;
   * a list gap would stack on top and double-space them. */
  gap: 0;
}
